import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AdminModule } from './view/admin/admin.module';
// import { ConnectComponent } from './view/connect/connect.component';
import { DashboardComponent } from './view/dashboard/dashboard.component';
import { SupportComponent } from './view/support/support.component';
// import { TrainingComponent } from './view/training/training.component';
// import { MarketingComponent } from './view/marketing/marketing.component';
// import { AccountComponent } from './view/account/account.component';
// import { ProfileComponent } from './view/profile/profile.component';
// import { PartnerprofileComponent } from './view/partnerprofile/partnerprofile.component';
import { MycompanyComponent } from './view/mycompany/mycompany.component';
// import { HelprequestComponent } from './view/support/helprequest/helprequest.component';
import { authGuard } from './auth/auth.guard';
import { LoginComponent } from './view/login/login.component';
import { AuthcheckComponent } from './view/authcheck/authcheck.component';
import { CoursewareComponent } from './view/courseware/courseware.component';
import { VssComponent } from './view/vss/vss.component';
// import { ClassesComponent } from './view/classes/classes.component';
import { LiveComponent } from './view/live/live.component';
// import { InstructorComponent } from './view/instructor/instructor.component';
import { VouchersComponent } from './view/vouchers/vouchers.component';
import { AnnouncementComponent } from './view/dashboard/announcement/announcement.component';
import { EmailUpdateFormComponent } from './view/email-update-form/email-update-form.component';
import { PreloginComponent } from './prelogin/prelogin.component';
import { FindYourFeeComponent } from './findyourfee/findyourfee.component';
import {HomeComponent} from './view/home/home.component';
import { ErrorComponent } from './view/error/error.component';
import { DomainErrorComponent } from './view/domain-error/domain-error.component';
import { TechCommunityComponent } from './view/tech-community/tech-community.component';
import { ExtremeLabComponent } from './view/extreme-lab/extreme-lab.component';
import { TermsComponent } from './view/terms/terms.component';
import { AlumniRequestComponent } from './view/alumni-request/alumni-request.component';
import { ExpiredFormSubmissionComponent } from './view/expired-form-submission/expired-form-submission.component';
import { ReinstateRequestComponent } from './view/reinstate-request/reinstate-request.component';
// import { ModeSelectionComponent } from './view/mode-selection/mode-selection.component';

const routes: Routes = [
  {
    path:'dashboard',
    component:DashboardComponent,
    title: 'Dashboard - Microsoft Certified Trainer Portal',
    canActivate: [authGuard]
  },
  // {
  //   path:'mode-selection',
  //   component:ModeSelectionComponent,
  //   canActivate: [authGuard]
  // },
  {
    path : 'home',
    component:HomeComponent,
    canActivate:[authGuard]
  },
  {
    path:'emailupdate',
    component:EmailUpdateFormComponent,
    canActivate:[authGuard]
  },
  {
    path:'prelogin',
    title: 'Microsoft Certified Trainer Portal',
    component:PreloginComponent
  },
  {
    path:'find-your-fee',
    component:FindYourFeeComponent
  },
  {
    path:'tech-communities',
    component:TechCommunityComponent,
    canActivate:[authGuard]
  },
  {
    path:'extreme-labs',
    component:ExtremeLabComponent,
    canActivate:[authGuard]
  },
  {
    path:'terms',
    component:TermsComponent,
    canActivate:[authGuard]
  },
  {
    path:'courseware',
    component:CoursewareComponent,
    canActivate: [authGuard]
  },
  {
    path:'vss',
    component:VssComponent,
    canActivate:[authGuard]
  },
  // {
  //   path:'classes',
  //   component:ClassesComponent,
  //   canActivate: [authGuard]
  // },
  {
    path:'live',
    component:LiveComponent,
    canActivate: [authGuard]
  },
  // {
  //   path:'instructor',
  //   component:InstructorComponent,
  //   canActivate: [authGuard]
  // },
  {
    path:'vouchers',
    component:VouchersComponent,
    canActivate: [authGuard]
  },
  {
    path:'alumni-request',
    component:AlumniRequestComponent,
    canActivate: [authGuard]
  },
  {
    path:'reinstatement-mct',
    component: ReinstateRequestComponent,
    canActivate: [authGuard]
  },
  {
    path:'expired-mct',
    component: ExpiredFormSubmissionComponent,
    canActivate: [authGuard]
  },
  // {
  //   path:'training',
  //   component:TrainingComponent,
  //   // canActivate: [authGuard]
  // },
  // {
  //   path:'marketing',
  //   component:MarketingComponent,
  //   // canActivate: [authGuard]
  // },
  // {
  //   path:'connect',
  //   component:ConnectComponent,
  //   // canActivate: [authGuard]
  // },
  {
    path:'support',
    component:SupportComponent,
    canActivate: [authGuard]
  },
  // {
  //   path:'account',
  //   component:AccountComponent,
  //   // canActivate: [authGuard]
  // },
  // {
  //   path:'profile',
  //   component:ProfileComponent,
  //   canActivate: [authGuard]
  // },
  // {
  //   path:'partnerprofile/:id',
  //   component:PartnerprofileComponent
  // },
  {
    path:'mycompany',
    component:MycompanyComponent,
    canActivate:[authGuard]
  },
  // {
  //   path:'help',
  //   component:HelprequestComponent,
  //   //canActivate: [authGuard]
  // },
    {
    path:'error',
    component:ErrorComponent,
    //canActivate: [authGuard]
  },
   {
    path:'domain-error',
    component:DomainErrorComponent,
    //canActivate: [authGuard]
  },
  {
    path:'announcement',
    component:AnnouncementComponent,
    canActivate: [authGuard]
  },
  { 
    path: 'admin',
    loadChildren: () => import('./view/admin/admin-routing.module').then(m => m.AdminRoutignModule),
    canActivate: [authGuard]
  },
  {
    path: 'login',
    component: LoginComponent,
    // canActivate: [authGuard]
    // redirectTo: '/profile',
    // pathMatch: 'full'
  },
  {
    path: "authcheck",
    component: AuthcheckComponent
  },
  {
    path: '',
    redirectTo: '/login',
    pathMatch: 'full'
  },
  
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
